import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Autocomplete, Box, Checkbox, Grid, TextField } from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect, useState } from "react";
import MultipleSelectChip from "../HubDetails/Topology/MultipleSelectChip";
import { getDecodeURI, getEncodedURI } from "../../utils/util";
import BarIcon from '../../asset/image/NewBarIcon.svg';
import PieIcon from '../../asset/image/NewPieIcon.svg';
import _ from "lodash";
import analyticsdata from './analyticsData.json';
import LineChartIcon from '../../asset/image/LineChartIcon.svg';
import ColumnChartIcon from '../../asset/image/ColumnChartIcon.svg';

const AnalyticsFilters = (props) => {
    const { activeTab, subTab, chartType, setChartType, isCardExpanded, setIsCardExpanded, isLeftChartsExpanded, setIsLeftChartsExpanded, sites, setSites, rightChartType, setRightChartType, location, history, visibleColumns,
        setVisibleColumns, selectedColumns, setSelectedColumns, getDrawerOpen } = props;
    const _q = getDecodeURI(location?.search);
    const [cardHeadings, setCardHeadings] = useState<any>([]);
    const [selectedCards, setSelectedCards] = useState<any>([]);
    const [cardsCount, setCardsCount] = useState<number>(0);
    const [isCardsExpanded, setIsCardsExpanded] = useState(true);
    const [isGraph1Expanded, setIsGraph1Expanded] = useState(true);
    const [isGraph2Expanded, setIsGraph2Expanded] = useState(true);
    const [availableColumns, setAvailableColumns] = useState([]);
    const [isColumnsExpanded, setIsColumnsExpanded] = useState(true);

    useEffect(() => {
        const columnData = analyticsdata?.[activeTab]?.[subTab]?.table?.tableKeys?.columns || [];
        const filterableColumns = columnData.filter(col => col.status !== 'internal');
        const activeColumns = filterableColumns.filter(col => col.status === 'active');

        const newAvailableLabels = filterableColumns.map(col => col.label);
        const newActiveLabels = activeColumns.map(col => col.label);
        const newVisibleKeys = activeColumns.map(col => col.key);

        setAvailableColumns(newAvailableLabels);

        const isInvalidSelection = !selectedColumns?.every(sel => newAvailableLabels.includes(sel));

        const shouldReset =
            (!selectedColumns || selectedColumns.length === 0 || isInvalidSelection) &&
            (!visibleColumns || visibleColumns.length === 0);

        if (shouldReset) {
            console.log("[RESET] Resetting visibleColumns and selectedColumns due to empty or invalid state");
            setSelectedColumns(newActiveLabels);

            const selectedKeys = columnData
                .filter(col => newActiveLabels.includes(col.label))
                .map(col => col.key);

            setVisibleColumns(selectedKeys);
        }
    }, [activeTab, subTab]);

    useEffect(() => {
        if (!analyticsdata || typeof analyticsdata !== "object") return;

        const headings = analyticsdata?.[activeTab]?.[subTab]?.topCard?.cardContent?.map((item: any, index) => {
            return { heading: item[index]?.['heading'], cardIndex: index };
        }) || [];
        setCardHeadings(headings);

        const defaultNumberOfCards = analyticsdata?.[activeTab]?.[subTab]?.topCard?.['defaultNumberOfCards']
            ? parseInt(analyticsdata?.[activeTab]?.[subTab]?.topCard?.['defaultNumberOfCards'])
            : headings.length;
        setCardsCount(defaultNumberOfCards);

        const selectedIndexes = _q?.cardIndexes
            ? _q?.cardIndexes?.split(',').map(Number)
            : headings?.slice(0, defaultNumberOfCards).map(item => item.cardIndex);

        const filteredHeadings = headings?.filter(item => selectedIndexes.includes(item.cardIndex));
        setSelectedCards(filteredHeadings);
    }, [activeTab, subTab]);

    const handleColumnSelection = (newSelection) => {
    const orderedSelection: string[] = availableColumns.filter((label: string) =>
    (newSelection as string[]).includes(label)
); 
    setSelectedColumns(orderedSelection);
    const columnData = analyticsdata?.[activeTab]?.[subTab]?.table?.tableKeys?.columns || [];
    const selectedKeys = columnData
        .filter(col => orderedSelection.includes(col.label))
        .map(col => col.key);
    if (setVisibleColumns) {
        setVisibleColumns(selectedKeys);
    }
};

    const handleCardSelection = (newSelection) => {
    const orderedSelection = cardHeadings.map(card => card.heading).filter(heading => newSelection.includes(heading));
    const selectedCardsWithIndex = orderedSelection.map((heading) =>
        cardHeadings.find((card) => card.heading === heading)
    ).filter(Boolean);
    setSelectedCards(selectedCardsWithIndex);

    const selectedIndexes = selectedCardsWithIndex.map((card) => card.cardIndex).join(',');

    const params = getDecodeURI(location?.search);
    params.cardIndexes = selectedIndexes;
    history.push({ pathname: location.pathname, search: getEncodedURI(params) });
};

    const handleChartType = (type) => {
        setChartType(type);
    }

    const handleRightChartType = (type) => {
        setRightChartType(type);
    }

    const handleCardsCheckboxChange = (event) => {
        setIsCardExpanded(event.target.checked);
    };

    const handleLectChartsCheckboxChange = (event) => {
        setIsLeftChartsExpanded(event.target.checked);
    };

    return (
        <Box className="l-shaped-filters" style={getDrawerOpen ? { left: '237px' } : { left: '114px' }}>
            <>
                <Grid className="analytics-filters-fields-container">
                    <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={isCardExpanded} onChange={handleCardsCheckboxChange} />
                    <div className="fields-title-icon">
                        <span className="fields-title">Cards</span>
                        {isCardsExpanded ? (
                            <KeyboardArrowDownIcon onClick={() => setIsCardsExpanded(prevState => !prevState)} />
                        ) : (
                            <KeyboardArrowUpIcon onClick={() => setIsCardsExpanded(prevState => !prevState)} />
                        )}
                    </div>
                </Grid>
                {isCardsExpanded && <div className="siteCharts__filters">
                    <MultipleSelectChip defaultSelection={selectedCards?.map(card => card.heading)} handleSelection={handleCardSelection} values={cardHeadings?.map(card => card.heading)} name={'Cards'} sx={{ maxWidth: "250px", width: "250px", marginLeft: "4px" }} limitValue={2} cardsCount={cardsCount} />
                </div>}
            </>
            <>
                <Grid className="analytics-filters-fields-container">
                    <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={isCardExpanded} onChange={handleCardsCheckboxChange} />
                    <div className="fields-title-icon">
                        <span className="fields-title">Columns</span>
                        {isColumnsExpanded ? (
                            <KeyboardArrowDownIcon onClick={() => setIsColumnsExpanded(prev => !prev)} />
                        ) : (
                            <KeyboardArrowUpIcon onClick={() => setIsColumnsExpanded(prev => !prev)} />
                        )}
                    </div>
                </Grid>
                {isColumnsExpanded && (
                    <div className="siteCharts__filters">
                        <MultipleSelectChip
                            defaultSelection={selectedColumns}
                            handleSelection={handleColumnSelection}
                            values={availableColumns}
                            name={'Columns'}
                            sx={{ maxWidth: "250px", width: "250px", marginLeft: "4px" }}
                            limitValue={2}
                        />

                    </div>
                )}


            </>
            <>
                <Grid className="analytics-filters-fields-container">
                    <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={isLeftChartsExpanded} onChange={handleLectChartsCheckboxChange} />
                    <div className="fields-title-icon">
                        <span className="fields-title">Graph 1</span>
                        {isGraph1Expanded ? (
                            <KeyboardArrowDownIcon onClick={() => setIsGraph1Expanded(prev => !prev)} />
                        ) : (
                            <KeyboardArrowUpIcon onClick={() => setIsGraph1Expanded(prev => !prev)} />
                        )}

                    </div>
                </Grid>
                {isGraph1Expanded && (
                    <Grid className="analytics-bar-chart-icons filters-graph1-icons">
                        <img src={BarIcon} className={chartType == 'bar' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('bar')} alt="bar" style={{ transform: "rotate(90deg) scaleX(-1)" }} />
                        <img src={BarIcon} className={chartType == 'column' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('column')} alt="bar" />
                        <img src={PieIcon} className={chartType == 'pie' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleChartType('pie')} alt="pie" />
                    </Grid>)}
                {/* <Autocomplete
                    className="select-site-input"
                    fullWidth
                    size="small"
                    multiple
                    limitTags={1}
                    ListboxProps={{ className: 'warehouse-apply-config-props' }}
                    id="multiple-limit-tags"
                    options={sitesList.map((site, index) => ({ ...site, key: `${site.name}-${index}` }))}
                    getOptionLabel={(option: any) => option.name}
                    value={sites.map((site, index) => ({ ...site, key: `${site.name}-${index}` }))}
                    getOptionDisabled={(option: any) => {
                        let vesselOption = "All Sites";
                        if (sites.findIndex(item => item?.name === vesselOption) !== -1) {
                            return true;
                        }
                        if (option.name === vesselOption && sites[0]?.name && sites[0]?.name !== vesselOption) {
                            return true;
                        }
                        if (sites.some(ele => ele.name === option.name)) {
                            return true;
                        }
                        return false;
                    }}
                    onChange={(e, newValue) => handleChangeSite(e, newValue)}
                    renderInput={(params) => (
                        <TextField {...params} label="" required placeholder="Select Sites" InputLabelProps={{
                            style: { fontSize: '11px', marginTop: '5px', lineHeight: '1' }, shrink: true // 🔹 Change label font size
                        }} style={{ fontSize: '11px', margin: '10px 0 0 5px' }} />
                    )}
                    renderOption={(props, option, { index }) => (
                        <li {...props} key={`${option.name}-${index}`}>
                            {option.name}
                        </li>
                    )}
                /> */}
            </>
            <>
                <Grid className="analytics-filters-fields-container">
                    <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={isLeftChartsExpanded} onChange={handleLectChartsCheckboxChange} />
                    <div className="fields-title-icon">
                        <span className="fields-title">Graph 2</span>
                        {isGraph2Expanded ? (
                            <KeyboardArrowDownIcon onClick={() => setIsGraph2Expanded(prev => !prev)} />
                        ) : (
                            <KeyboardArrowUpIcon onClick={() => setIsGraph2Expanded(prev => !prev)} />
                        )}

                    </div>
                </Grid>
                {isGraph2Expanded && (
                    <Grid className="analytics-bar-chart-icons filters-graph1-icons">
                        <img src={LineChartIcon} className={rightChartType == 'spline' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleRightChartType('spline')} alt="line" />
                        <img src={ColumnChartIcon} className={rightChartType == 'column' ? 'iconColor-select' : 'iconColor-unselect'} onClick={() => handleRightChartType('column')} alt="column" />
                    </Grid>
                )}
            </>
        </Box>
    );
};
const mapStateToProps = (state) => ({
    getDrawerOpen: state.authReducer.getDrawerOpen
});

export default withRouter(
    connect(mapStateToProps, { })(AnalyticsFilters)
);
